import {
  MDBBtn,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBRow,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import React from "react";
import NotificationTemplateModal from "./NotificationTemplateModal";
import NotificationTemplateViewModal from "./NotificationTemplateViewModal";
import { useState } from "react";
import { useEffect } from "react";
import {
  deleteNotificationTemplate,
  getNotificationTemplates,
} from "../../../../apis/NotificationTemplateApi";
import { useDispatch } from "react-redux";
import { showHideLoader, showNotification } from "../../../../actions";
import { confirm as DevExtremeConfirm } from "devextreme/ui/dialog";

function NotificationTemplate() {
  const dispatch = useDispatch();
  const initialTemplateState = {
    id: "",
    name: "",
    eventType: "",
    type: "",
    subject: "",
    template: "",
  };
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [showTemplateViewModal, setShowTemplateViewModal] = useState(false);
  const [notificationTemplates, setNotificationTemplates] = useState([]);
  const [templateData, setTemplateData] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [edit, setEdit] = useState(false);
  const [templatePayload, setTemplatePayload] = useState(initialTemplateState);
  const [reload, setReload] = useState(false);

  const handleTemplateModalClose = () => {
    setShowTemplateModal(false);
    setEdit(false);
    setTemplatePayload(initialTemplateState);
  };

  const handleTemplateViewModalClose = () => {
    setShowTemplateViewModal(false);
  };

  const handleEditTemplate = (template) => {
    setEdit(true);
    setTemplatePayload({
      id: template.id,
      typeId: template.notification_type.id,
      eventTypeId: template.notification_event_type.id,
      subject: template.subject,
      template: template.template,
    });
    setShowTemplateModal(true);
  };

  useEffect(() => {
    dispatch(showHideLoader(true));
    getNotificationTemplates().then((res) => {
      const templates = res.data.data;
      setNotificationTemplates(templates);
      dispatch(showHideLoader(false));
    });
  }, [showTemplateModal, reload]);

  const handleDeleteTemplate = (id, name) => {
    let result = DevExtremeConfirm(
      `Are you sure you want to delete <b>${name ? name : "Template"}</b>?`,
    );

    result.then(async (dialogResult) => {
      if (dialogResult) {
        dispatch(showHideLoader(true));

        try {
          let response = await deleteNotificationTemplate(id);
          dispatch(showNotification("success", response.data.message));
        } catch (err) {
          dispatch(showNotification("error", err.data.message));
        } finally {
          dispatch(showHideLoader(false));
          setReload(!reload);
        }
      }
    });
  };

  return (
    <>
      <NotificationTemplateModal
        showModal={showTemplateModal}
        onClose={() => handleTemplateModalClose()}
        templateData={templatePayload}
        isEdit={edit}
      />
      <NotificationTemplateViewModal
        showModal={showTemplateViewModal}
        onClose={() => handleTemplateViewModalClose()}
        templateValue={templateData}
        templateName={templateName}
      />
      <MDBContainer>
        <MDBRow>
          <MDBCol md="12">
            <MDBRow className="mb-12">
              <MDBCol md="6">
                <h3 className="mt-3">Notifications Templates</h3>
              </MDBCol>
              <MDBCol md="6">
                <MDBBtn
                  color="primary"
                  className="float-right"
                  onClick={() => setShowTemplateModal(true)}
                >
                  Create New Template
                </MDBBtn>
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>
        <MDBTable
          responsive
          striped
          bordered
          hover={true}
          scrollY={true}
          maxHeight="80vh"
          style={{ marginTop: "15px" }}
        >
          <MDBTableHead>
            <tr>
              <th className="text-center">Organisation</th>
              <th className="text-center"> Type</th>
              <th className="text-center">Event Type</th>
              <th className="text-center">Subject</th>
              <th className="text-center">Template</th>
              <th className="text-center">Actions</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {notificationTemplates &&
              notificationTemplates.map((temp) => (
                <tr key={temp.id}>
                  <td className="text-center">{temp.organisation.name}</td>
                  <td className="text-center">{temp.notification_type.name}</td>
                  <td className="text-center">
                    {temp.notification_event_type.name}
                  </td>
                  <td className="text-center">{temp.subject}</td>
                  <td className="text-center">
                    <MDBBtn
                      color="link"
                      className="p-0"
                      onClick={() => {
                        setTemplateData(temp.template);
                        setShowTemplateViewModal(true);
                        setTemplateName(temp.name);
                      }}
                    >
                      Preview
                    </MDBBtn>
                  </td>
                  <td className="text-center">
                    <MDBIcon
                      style={{ cursor: "pointer" }}
                      icon="edit"
                      className="cyan-text mr-2"
                      onClick={() => handleEditTemplate(temp)}
                    />
                    <MDBIcon
                      style={{ cursor: "pointer" }}
                      icon="trash"
                      className="danger-text"
                      onClick={() => handleDeleteTemplate(temp.id, temp.name)}
                    />
                  </td>
                </tr>
              ))}
          </MDBTableBody>
        </MDBTable>
      </MDBContainer>
    </>
  );
}

export default NotificationTemplate;
